var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgMiaoliDisplayBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 864,
    height: 358,
    viewBox: "0 0 864 358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_644",
    x: 226.26,
    y: 199.452,
    width: 55.593,
    height: 67.282,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.134,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f9f7f7",
    floodOpacity: 0.749
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_645",
    x: 368.699,
    y: 114.59,
    width: 55.593,
    height: 67.282,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.134,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f9f7f7",
    floodOpacity: 0.749
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_646",
    x: 167.898,
    y: 114.59,
    width: 49.537,
    height: 59.934,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.134,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f9f7f7",
    floodOpacity: 0.749
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_647",
    x: 413.034,
    y: 199.452,
    width: 111.845,
    height: 67.282,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.134,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f9f7f7",
    floodOpacity: 0.749
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M-2601.156,812.126c3.653-.615,45.169,0,45.169,0v18.447l42.863,62.755v22.85H-2607V812.126Z",
    transform: "translate(2607 -811.853)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_495",
    x: 574.666,
    y: 113.965,
    width: 76.624,
    height: 70.87,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.121,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#f9f7f7",
    floodOpacity: 0.749
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 864,
    height: 358
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(2769.064 925.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M-2670.447-883.213h-8.223l-.394-1.785h8.42l-.985-9.723,7.238.616a1.75,1.75,0,0,1-1.427,1.723l.787,7.384h1.33l2.856-5.046s3.3,3.446,5.219,5.846a1.186,1.186,0,0,1-1.33.985h-7.878l.739,6.462c-.788,1.292-2.905,1.969-5.515,1.846Zm27.131,7.015,5.564,5.416a3.535,3.535,0,0,1-1.969,1.353v29.477c-.1.493-2.856,1.97-4.875,1.97h-.936v-4.862h-22.059v3.015c0,.8-2.462,2.524-4.973,2.524h-.936v-38.278l6.4,3.139h21.075Zm-24.275,5.539v11.631h8.42v-11.631Zm0,26.031h8.42V-857.3h-8.42Zm28.756-45.416s3.3,3.446,5.269,5.846a1.268,1.268,0,0,1-1.379.985h-8.814l-.739,6.892c-.984,1.108-3.25,1.477-5.662.923l.837-7.815h-5.367l-.394-1.785h5.909l1.033-9.723,7.141,1.908c-.148.738-.542,1.292-1.872,1.354l-.689,6.461h1.822Zm-14.723,19.385v11.631h8.026v-11.631Zm8.026,26.031V-857.3h-8.026v12.677Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M-2602.008-858.044v18.831c0,.615-2.659,1.969-5.072,1.969h-1.083V-851.4a2.619,2.619,0,0,1-2.167.553,44.409,44.409,0,0,1-16.643,10.954l-.345-.615c4.924-3.939,10.292-11.508,12.31-16.123l6.845,4.43v-5.846h-16.446l-.444-1.723h16.89v-7.384l7.976.861c-.1.861-.492,1.477-1.821,1.785v4.738h9.109l3.151-5.292s3.644,3.569,5.811,6.031a1.289,1.289,0,0,1-1.428.984Zm14.082-37.723s3.644,3.446,5.811,5.846a1.248,1.248,0,0,1-1.33.985h-13.639v7.446h3.594l2.659-3.57,5.564,5.231a3.47,3.47,0,0,1-2.019,1.293v11.692c-.048.431-2.954,1.6-4.727,1.6H-2593v-2.339h-23.635v.616c0,.615-2.561,2.154-4.875,2.154h-.788v-19.631l6.106,2.954h3.84v-7.446h-13.984l-.345-1.723h35.5Zm-28.706,26.461h4.283v-10.4h-4.283Zm13.934-19.63h-4.136v7.446h4.136Zm-4.136,19.63h4.136v-10.4h-4.136Zm6.451,14.77c19.7,1.231,18.809,15.938,12.507,13.661-2.856-4.492-8.617-10.03-12.9-13.107Zm3.3-25.17v10.4H-2593v-10.4Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M-2537.164-870.352c11.227,6.339,6.4,17.047,2.414,12.247a22.6,22.6,0,0,0-.542-4.677c-1.083.43-2.265.861-3.545,1.353v16.862c0,4.185-.838,6.708-6.648,7.262a7.866,7.866,0,0,0-.837-4,5.035,5.035,0,0,0-3.595-1.908v-.8s3.939.308,4.875.308c.739,0,.936-.37.936-1.046v-14.832c-1.428.493-2.905.985-4.481,1.478a2.444,2.444,0,0,1-.591.861l5.023,2.954c-.247.615-.69.985-1.871.8-1.97,4.185-5.269,9.846-9.307,13.6l-.492-.677a65.59,65.59,0,0,0,5.81-17.231l.295.185-1.231-3.138a1.1,1.1,0,0,1-1.231.861h-9.306V-838.6c0,.246-1.625,1.354-4.235,1.354h-.935V-854.6a2.151,2.151,0,0,1-1.133.308,36.053,36.053,0,0,1-7.78,12.985l-.64-.554a71.358,71.358,0,0,0,3.742-16.062l5.811,2.092v-4.061h-8.913l-.393-1.785h3.052v-31.631l5.417,2.647h6.4l2.216-3.139,4.924,4.615a3.64,3.64,0,0,1-1.921,1.17v24.492l.985-1.6s2.364,2.339,3.841,4.123l-1.133-3.015a6.328,6.328,0,0,0,1.724-.615,37.7,37.7,0,0,0,7.78-7.631c-1.97.861-4.284,1.907-6.746,2.83a2.952,2.952,0,0,1-1.083,1.539l-2.61-7.077a5.785,5.785,0,0,0,1.428-.554c2.905-1.908,6.7-7.754,8.223-11.138a60.52,60.52,0,0,1-11.178,4.246l-.246-.8a52.67,52.67,0,0,0,13.738-11.631l5.663,4.615c-.394.677-1.281.862-2.708.493a40.225,40.225,0,0,1-4.727,2.769l5.81,3.631c-.2.554-.739.984-1.773.8a49.888,49.888,0,0,1-9.848,7.815c2.216,0,5.121-.061,8.125-.184a43.012,43.012,0,0,0,4.087-6.524l6.155,4.246a1.621,1.621,0,0,1-1.97.8,75.189,75.189,0,0,1-14.969,12.492c3.1-.123,7.239-.308,11.572-.554a52.3,52.3,0,0,0-1.921-5.477Zm-30.971-18.584v5.292h7.533v-5.292Zm7.533,7.015h-7.533v5.354h7.533Zm-7.533,7.077v5.231h7.533v-5.231Zm0,13.169h7.533v-6.154h-7.533Zm7.78,4.185c10.488,5.231,5.563,15.077,1.772,10.4a22.953,22.953,0,0,0-2.314-10.031Zm22.749,0c12.26,8.246,7.041,20.246,2.56,14.708a42.614,42.614,0,0,0-3.1-14.4Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M-2510.037-886.6s2.61,2.585,4.235,4.493a1.216,1.216,0,0,1-1.33.984h-16.889l-.394-1.723h12.064Zm-3.792,11.57,2.118-3.508s2.462,2.461,3.939,4.246a1.137,1.137,0,0,1-1.28.984h-13.541l-.394-1.722Zm2.118,4.43s2.462,2.462,3.939,4.246a1.137,1.137,0,0,1-1.28.985h-13.541l-.394-1.723h9.158Zm4.727,12.8a3.526,3.526,0,0,1-1.724,1.108v14.338c-.049.493-2.511,1.908-4.185,1.908h-.837v-3.077h-3.89v3.816c0,.554-2.117,1.969-4.234,1.969h-.69v-24.185l5.121,2.647h3.25l2.314-3.078Zm-13.443-35.938c12.655.738,8.125,12.677,3.1,8.492a19.4,19.4,0,0,0-3.546-8.123Zm6.7,48.492v-12.308h-3.89v12.308Zm27.525-24.861c6.254,1.046,6.3,5.354,4.58,6.708.935.984,2.659,2.707,3.84,4.061a1.215,1.215,0,0,1-1.329.984h-4.53l4.874,3.631c-.344.616-.836.923-2.018.554a35.436,35.436,0,0,1-3.94,5.662,12,12,0,0,0,2.462,3.569c.542.492.788.492,1.133-.308a51.888,51.888,0,0,0,1.822-5.415l.541.123-.59,7.139c1.28,2.338,1.427,3.507.935,4.553-1.428,2.339-4.481.862-6.056-.677a21.976,21.976,0,0,1-3.693-5.169,33.622,33.622,0,0,1-8.174,5.723l-.493-.8a43.837,43.837,0,0,0,7.239-8.308,45.209,45.209,0,0,1-2.167-10.277h-4.628v3.385l3.939-.923.1.8c-1.132.738-2.412,1.662-4.037,2.708v7.754c0,4-.739,6.4-6.008,6.954a7.265,7.265,0,0,0-.837-3.693c-.591-.8-1.477-1.415-3.446-1.846v-.8s3.791.308,4.677.308c.739,0,.886-.37.886-1.046v-4.739q-1.476.922-3.1,1.846a2.291,2.291,0,0,1-1.181,1.477l-2.216-6.523c1.329-.185,3.693-.615,6.5-1.231v-4.431h-6.5l-.394-1.723h6.893v-4.553c-1.92.369-3.938.676-5.81.861l-.246-.923a45.484,45.484,0,0,0,10.193-6.031h-10.291l-.394-1.723h11.472v-5.169h-7.878l-.394-1.723h8.272v-5.169h-9.7l-.394-1.724h8.026a3.288,3.288,0,0,1-1.231-.738,18.167,18.167,0,0,0-3.052-7.569l.393-.369c8.814,1.107,8.223,7.63,5.417,8.676h4.875A84.375,84.375,0,0,0-2490-895.09l6.943,2.585a1.506,1.506,0,0,1-1.822,1.107,42.682,42.682,0,0,1-5.367,5.169h4.234l2.61-4.061s2.954,2.769,4.826,4.8a1.186,1.186,0,0,1-1.33.985h-11.03v5.169h2.906l2.511-3.939s2.807,2.708,4.53,4.677a1.216,1.216,0,0,1-1.33.985h-8.617v5.169h5.269l2.708-4.369s3.1,2.954,5.022,5.107a1.213,1.213,0,0,1-1.329.985h-16.446l3.447,3.754c-.05-1.108-.05-2.154-.05-3.385l5.614.616Zm-5.712,10.03c-.147-1.969-.246-3.938-.344-6.03a3.06,3.06,0,0,1-2.216-.308c-.591.184-1.231.431-1.92.615v5.723Zm8.913-2.83a2.649,2.649,0,0,1-1.527-.8,14.719,14.719,0,0,0-1.674-5.292,2.034,2.034,0,0,1-1.378.985c0,2.708.049,5.354.246,7.938h2.659Zm-4.136,4.553a36.064,36.064,0,0,0,.738,4.862,51.161,51.161,0,0,0,2.265-4.862Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M-2444.8-892.628c-.147.738-.738,1.107-2.363,1.353,4.53,5.231,13.64,8.37,20.631,9.723v.862c-2.412.984-3.988,4.123-4.283,6.892a29.652,29.652,0,0,1-3.595-1.908l2.364,2.216a2.15,2.15,0,0,1-1.231.862V-861c-.05.493-2.66,1.785-4.333,1.785h-.887V-861H-2461v.493a1.9,1.9,0,0,1-.689,1.046l5.022,2.461h13.689l2.512-3.2,5.071,4.677a2.2,2.2,0,0,1-1.329.923v15.016c-.049.554-2.807,2.215-4.826,2.215h-.985v-3.2h-14.427v1.17c0,.676-2.56,2.276-4.924,2.276h-.788v-21.661a5.315,5.315,0,0,1-2.56.615h-.887v-16.738a59.285,59.285,0,0,1-6.154,2.83l-.3-.738c8.223-5.231,17.086-15.508,19.253-22.462Zm7.879,15.322a32.893,32.893,0,0,1-11.03-13.292c-3.2,5.046-9.11,10.277-15.56,14.154l3.152,1.539h21.517ZM-2461-862.782h8.765v-10.339H-2461Zm1.822-9.723c9.011,4,4.333,12,1.133,7.938a18.8,18.8,0,0,0-1.674-7.631Zm13.246-11.324s2.708,2.646,4.382,4.616a1.165,1.165,0,0,1-1.28.984h-13.935l-.394-1.723h8.765Zm-11.03,28.616v5.538h14.427v-5.538Zm14.427,12.861v-5.6h-14.427v5.6Zm4.038-30.769h-8.863v10.339h1.379c.788-2.893,1.674-6.831,2.166-9.723l5.318,2.215Zm0,10.339v-6.524a2.077,2.077,0,0,1-1.329.247,65.2,65.2,0,0,1-4.777,6.277Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M-2420.38-862.167h13.639v4.185h-13.639Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M-2375.672-876.751c1.772,11.938,7.632,24.184,21.616,31.753l-.049.739c-3,.615-4.776,2.892-5.416,6.954-11.276-8.924-15.167-23.816-16.644-36.37a53.28,53.28,0,0,1-5.071,18.278c13.59,5.907,7.681,18.892,2.314,12.861a31.734,31.734,0,0,0-3.1-11.446c-3.595,6.4-9.307,12.123-18.219,16.861l-.492-.923c13.885-11.323,17.628-24.492,18.612-38.707h-17.283l-.443-1.724h17.874c.3-5.292.246-10.708.246-16.246l8.223,1.046c-.1.862-.541,1.477-1.772,1.723-.1,4.554-.2,9.047-.493,13.477h10.636l3.594-5.661s4.038,3.815,6.4,6.4a1.29,1.29,0,0,1-1.428.985Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M-2307.233-864.505l4.875,5.046a2.844,2.844,0,0,1-2.019,1.046c-.837,11.2-2.413,16.985-4.973,19.262a7.836,7.836,0,0,1-5.663,1.907,8.607,8.607,0,0,0-.738-4.307,5.306,5.306,0,0,0-3.349-2.031l.049-.862c1.379.123,3.743.308,4.727.308a2.259,2.259,0,0,0,1.625-.492c1.281-1.231,2.511-6.216,3.152-14.831h-1.281a35.045,35.045,0,0,1-19.253,22.277l-.492-.923c7.189-5.046,11.818-12.493,14.231-21.354h-1.477a38.445,38.445,0,0,1-16.742,17.415l-.493-.923a42.843,42.843,0,0,0,12.114-16.492h-1.625a31.894,31.894,0,0,1-10.095,8.431l-.1-.246a6.49,6.49,0,0,1-4.432,1.538,17.7,17.7,0,0,0-.591-5.169,3.07,3.07,0,0,0-1.969-1.477v17.046c0,.492-1.674,2.154-4.284,2.154h-.936v-56.185l5.86,2.831h3.25l2.856-3.446,5.268,6.276c-.393.554-1.083.739-2.166.739a118.374,118.374,0,0,1-7.091,13.477,19.635,19.635,0,0,1,6.549,14.462,16.948,16.948,0,0,1-.64,5.046,35.273,35.273,0,0,0,6.549-12.062h-6.2l-.394-1.785h23l2.757-4.738s3.25,3.261,5.171,5.539a1.217,1.217,0,0,1-1.33.984h-17.185a29.231,29.231,0,0,1-2.609,4.862h13.393Zm-32.3,7.323a1.711,1.711,0,0,0,1.133-.308c.542-.431.886-1.538.886-3.385a26.9,26.9,0,0,0-2.708-12.431c.887-3.877,2.068-10.769,2.758-15.507h-4.284v31.631Zm15.314-14.277c0,.492-1.625,1.6-4.235,1.6h-.886v-23.816l5.613,2.708h10.489l2.511-3.508,4.875,4.554a2.55,2.55,0,0,1-1.822,1.17v16.307c0,.246-1.773,1.477-4.432,1.477h-.935v-2.339h-11.178Zm0-17.724v6.216h11.178v-6.216Zm11.178,14.093v-6.093h-11.178v6.093Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M-2252.63-846.536a2.972,2.972,0,0,1,1.92,3.139c0,3.015-2.118,4.43-10.242,4.43h-4.875c-5.022,0-6.2-1.354-6.2-6.461v-23.447h-5.219c-.936,15.447-5.269,26.277-19.894,31.57l-.246-.677c10.636-7.262,13.246-17.6,13.541-30.893h-13l-.394-1.784h19.992v-24.37l7.829.862c-.1.861-.493,1.477-1.822,1.723v21.785h11.03l3.348-5.231s3.693,3.508,5.958,6.031a1.267,1.267,0,0,1-1.379.984h-13.885v21.6c0,.984.295,1.353,1.772,1.353h4.038c1.477,0,2.708-.061,3.4-.123.64-.061.887-.246,1.232-.923a90.557,90.557,0,0,0,2.363-9.354h.541Zm-39.737-44.493c15.806,6.954,10.389,22.093,4.579,15.939a39.048,39.048,0,0,0-5.023-15.569Zm38.6,3.877a1.67,1.67,0,0,1-2.019.985,68,68,0,0,1-11.424,12.8l-.541-.492a170.612,170.612,0,0,0,6.1-17.724Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M-2199.013-881.982c-.394.553-.886.676-1.871.738a32.051,32.051,0,0,1-6.2,5.969l-.493-.369.2-1.107c-.345.246-.787.184-1.378-.37a56.9,56.9,0,0,1-9.75,1.415l-.246-.676a55.3,55.3,0,0,0,8.026-6.216h-9.06v13.847c0,.307-1.773,1.477-4.678,1.477h-1.034V-882.6h-12.261a9.336,9.336,0,0,1,0,2.339c11.227-3.324,12.31,5.661,8.223,5.538a29.473,29.473,0,0,0-8.321-4.492,6.462,6.462,0,0,1-2.561,4.492,2.752,2.752,0,0,1-4.185-1.846,4.062,4.062,0,0,1,2.166-4.492,6.943,6.943,0,0,0,2.807-6.462l.739-.062a23.407,23.407,0,0,1,.886,3.2h12.507V-889h-13.2l-.394-1.723h25.752l2.905-4.554s3.3,3.077,5.318,5.293a1.216,1.216,0,0,1-1.329.984h-13.344v4.616h12.852l2.806-3.631Zm-2.905,36.554c2.117,1.107,2.314,1.292,2.314,2.461,0,2.585-1.674,4.185-7.484,4.185h-11.227c-6.007,0-7.288-1.416-7.288-8.308v-3.077h-7.632v2.585c0,.554-2.56,2.092-4.825,2.092h-.837v-23.631l1.428.739-1.428-4.554c2.215-.185,7.336-.923,12.31-1.662l.1.8c-1.969,1.416-4.973,3.385-9.109,5.846l-.148.369,2.856,1.416h20.632l1.723-2.338a42.517,42.517,0,0,0-8.519-4.739l.3-.861c11.325-2.031,13.491,4.676,11.227,6.338l3.348,3.2a3.093,3.093,0,0,1-1.921,1.293v13.6c-.049.554-2.806,1.969-4.727,1.969h-.984v-2.461h-8.174v3.446c0,2.031.2,2.154,2.068,2.154h11.128c1.379,0,2.068,0,2.462-.615.443-.616.985-2.4,1.773-5.662h.591Zm-31.317-18.954v5.292h7.632v-5.292Zm7.632,12.492v-5.477h-7.632v5.477Zm5.614-12.492v5.292h8.174v-5.292Zm8.174,12.492v-5.477h-8.174v5.477Zm4.431-24.985c.3-1.784.542-3.938.739-5.723h-3.89Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M-2153.913-849.736s3.988,3.815,6.4,6.462c-.148.676-.64.984-1.428.984H-2193.3l-.394-1.723h19.745v-39.508h-16.1l-.393-1.785h29.987l3.545-5.661s3.988,3.815,6.4,6.462a1.321,1.321,0,0,1-1.428.984H-2167.6v39.508h10.094Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M-2100.394-845.859s3.4,3.384,5.465,5.784a1.265,1.265,0,0,1-1.378.985h-29.3l-.394-1.785h12.458v-11.261h-9.6l-.394-1.723h10v-8.37c-2.955.37-5.959.554-8.814.677-.247,2.708-2.561,4.185-4.678,1.785a27,27,0,0,0-2.363-8.861v29.354c-.05.43-1.872,2.03-4.629,2.03h-1.034v-22.523a44.364,44.364,0,0,1-7.14,9.538l-.542-.615c3.5-6.4,5.811-15.138,7.14-23.446h-6.2l-.394-1.785h7.14v-9.231c-2.364.431-4.826.8-7.189,1.047l-.2-.739a59,59,0,0,0,14.23-10.031l6.451,6.77c-.64.676-1.674.8-3.25.184a39.371,39.371,0,0,1-4.382,1.416v10.584h.541l2.561-4.43s2.806,3.076,4.481,5.23a1.217,1.217,0,0,1-1.33.985h-6.253v3.815c4.923,2.216,6.794,5.354,7.041,7.877a87.174,87.174,0,0,0,17.579-8.246h-.3v-2.646h-11.03v1.661c0,.616-2.363,2.154-4.579,2.154h-.788v-22.953l5.614,2.83h10.34l2.56-3.569,5.417,5.169a3.352,3.352,0,0,1-1.92,1.293v14.154c-.05.43-2.118,1.538-3.94,1.846l5.565,6.584c-.591.677-1.724.677-3.25-.061-1.921.492-4.186.923-6.7,1.354v9.169h3.1l2.954-4.8s3.3,3.262,5.269,5.538a1.185,1.185,0,0,1-1.329.985h-10v11.261h4.431Zm-4.678-29.354v-12.862h-11.03v12.862Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M-2070.855-851.151c-.295.615-.739.922-1.871.615a43.448,43.448,0,0,1-16.249,10.646l-.394-.738a51.243,51.243,0,0,0,12.261-15.385Zm13.935-19.508c13.837,6.277,8.863,19.385,3.89,14.031a24.188,24.188,0,0,0-.837-5.17c-2.659.677-5.761,1.416-9.405,2.277v14.339c0,4.677-.936,7.446-7.386,8.061a10.72,10.72,0,0,0-.886-4.615c-.641-.862-1.576-1.661-3.89-2.093v-.8s4.234.307,5.219.307c.739,0,.936-.307.936-.984V-858.29c-3.447.8-7.189,1.539-11.227,2.338a3.179,3.179,0,0,1-1.231,1.477l-2.856-7.692a9.641,9.641,0,0,0,2.216-.554c4.234-1.723,9.552-5.354,14.231-9.169-3.4,1.108-7.337,2.4-11.72,3.569a2.837,2.837,0,0,1-.985,1.17l-2.708-7.139a6.3,6.3,0,0,0,1.724-.431c4.431-1.907,10.34-7.569,13.245-11.138a132.991,132.991,0,0,1-17.677,4.553l-.2-.923c8.519-3.138,19.105-8.861,24.374-13.046l5.613,5.6c-.542.677-1.477.8-2.954.185-2.167.985-4.826,2.092-7.731,3.077l5.367,3.877a1.586,1.586,0,0,1-2.018.677,67.257,67.257,0,0,1-13.788,7.692c3.5-.185,8.174-.554,13.1-.923a54.457,54.457,0,0,0,6.106-6.523l6.155,5.6a1.691,1.691,0,0,1-2.216.492c-4.973,4.185-15.117,9.908-23.783,13.6,5.86-.184,14.674-.738,23.931-1.353a41.4,41.4,0,0,0-3.053-7.016Zm-3.791,15.076c19.154,3.447,16.692,18.708,10.439,15.078-2.216-5.046-7.091-10.954-10.833-14.585Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M-2033.88-854.659c1.92,6.4,1.575,11.262.147,13.661a2.562,2.562,0,0,1-4.579-.43,4.32,4.32,0,0,1,1.33-4.924,13.873,13.873,0,0,0,2.363-8.307Zm-4.481-7.939a6.2,6.2,0,0,0,1.723-.8c2.314-2.155,5.121-6.462,7.534-10.77-1.674.861-3.545,1.723-5.564,2.646a3.116,3.116,0,0,1-1.231,1.354l-2.462-7.323a5.48,5.48,0,0,0,1.477-.677c2.462-3.077,5.662-12,6.6-16.677l6.6,4.123a1.415,1.415,0,0,1-1.625.862,64.942,64.942,0,0,1-9.405,12.676c2.019,0,4.53,0,7.19-.061a51.787,51.787,0,0,0,2.56-6.215l5.958,5.107a1.6,1.6,0,0,1-1.92.616,78.167,78.167,0,0,1-12.95,15.077c2.56-.185,5.908-.492,9.306-.738a33.109,33.109,0,0,0-1.773-5.662l.542-.37c10.193,5.785,5.662,15.324,1.92,10.954a18.271,18.271,0,0,0-.344-3.2,115.416,115.416,0,0,1-10.735,5.17,3.585,3.585,0,0,1-1.329,1.354Zm8.518,7.015c8.273,7.57,2.708,16.247-.492,11.139a38.469,38.469,0,0,0-.148-10.953Zm35.946,10.216a2.58,2.58,0,0,1,1.526,2.708c0,2.461-1.674,3.631-6.844,3.631h-2.66c-3.84,0-4.431-1.416-4.431-5.539v-23.139l-2.757.862c-.591,11.323-2.561,22.154-16.594,29.662l-.542-.862c9.8-8.246,11.128-17.662,11.424-27.077l-2.561.677a3.818,3.818,0,0,1-1.526,1.846l-2.659-8.184a4.747,4.747,0,0,0,1.772-.924c1.773-2.276,4.038-7.015,5.909-12h-6.8l-.394-1.723h7.829a79.858,79.858,0,0,0,2.906-10.03l7.484,4a1.706,1.706,0,0,1-1.822,1.046c-.739,1.538-1.625,3.2-2.61,4.984h6.6l2.906-4.923s3.348,3.385,5.367,5.662a1.268,1.268,0,0,1-1.379.984h-14.477a83.01,83.01,0,0,1-9.109,12.862c4.382-.123,10.833-.492,17.727-.923a45.848,45.848,0,0,0-4.087-7.569l.492-.431c15.117,5.723,10.784,19.446,5.466,14.462a25.309,25.309,0,0,0-1.281-4.862l-1.969.677V-846.1c0,.8.1,1.107.837,1.107h1.477a7.732,7.732,0,0,0,1.33-.061c.394-.062.591-.185.837-.739a69.213,69.213,0,0,0,1.871-7.877h.591Zm-31.071-11.261c9.552,4.123,5.023,13.107,1.477,8.984a20.5,20.5,0,0,0-2.019-8.615Z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(-4069 46.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(4295.661 153.525)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -226.66, -199.85)",
    filter: "url(#Rectangle_644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_644-2",
    "data-name": "Rectangle 644",
    transform: "translate(226.66 199.85)",
    fill: "none",
    stroke: "#9a9a9a",
    strokeMiterlimit: 10,
    strokeWidth: 3.208
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.791,
    height: 66.48,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.604,
    y: 1.604,
    width: 51.584,
    height: 63.272,
    rx: 4.396,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "ACP",
    transform: "translate(6.671 39.831)",
    fontSize: 20,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ACP"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(4438.1 68.662)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -369.1, -114.99)",
    filter: "url(#Rectangle_645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_645-2",
    "data-name": "Rectangle 645",
    transform: "translate(369.1 114.99)",
    fill: "none",
    stroke: "#9a9a9a",
    strokeMiterlimit: 10,
    strokeWidth: 3.208
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.791,
    height: 66.48,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.604,
    y: 1.604,
    width: 51.584,
    height: 63.272,
    rx: 4.396,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "DPC",
    transform: "translate(7.402 39.831)",
    fontSize: 20,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DPC"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(4237.299 68.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895",
    transform: "translate(12.321 21.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M-2500.347,820.07c-.851-3.179-1.212-3.042-3.843-1.406,2.125,6.09-1.644,13.115-9.049,10.756a1.394,1.394,0,0,0-1.383,2.377c.344-.2,8.781,8.3,8.46,5.745l-1.35-4.617A10.669,10.669,0,0,0-2500.347,820.07Z",
    transform: "translate(2522.145 -807.157)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M-2507.119,814.045c-.417-.021-7.981-7.208-8.371-6.174-.428-.013,1.289,4.876,1.263,5.053a10.688,10.688,0,0,0-6.2,15.291c.361.829,2.437-.963,2.882-1.031-.709-3.882-1.467-7.872,3.039-10.361a7.155,7.155,0,0,1,6.006-.4,1.394,1.394,0,0,0,1.381-2.382Z",
    transform: "translate(2521.732 -807.769)",
    fill: "#9a9a9a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M-2495.446,805.514h-27.732c-2.97.1-1.631-5.041-1.912-6.694a1.912,1.912,0,0,1,1.912-1.912h27.732a1.912,1.912,0,0,1,1.913,1.912C-2493.856,800.48-2492.446,805.607-2495.446,805.514Z",
    transform: "translate(2533.838 -787.04)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -168.3, -114.99)",
    filter: "url(#Rectangle_646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_646-2",
    "data-name": "Rectangle 646",
    transform: "translate(168.3 114.99)",
    fill: "none",
    stroke: "#9a9a9a",
    strokeMiterlimit: 10,
    strokeWidth: 2.853
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.735,
    height: 59.132,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.427,
    y: 1.427,
    width: 45.882,
    height: 56.279,
    rx: 4.573,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("text", {
    id: "INV",
    transform: "translate(9.497 73.375)",
    fontSize: 14,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500,
    letterSpacing: "0.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "INV"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(4482.435 153.525)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -413.43, -199.85)",
    filter: "url(#Rectangle_647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_647-2",
    "data-name": "Rectangle 647",
    transform: "translate(413.43 199.85)",
    fill: "none",
    stroke: "#9a9a9a",
    strokeMiterlimit: 10,
    strokeWidth: 3.208
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111.044,
    height: 66.48,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.604,
    y: 1.604,
    width: 107.836,
    height: 63.272,
    rx: 4.396,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "\\u8E89\\u552E\\u96FB\\u7BB1",
    transform: "translate(13.246 39.705)",
    fontSize: 20,
    fontFamily: "NotoSansCJKtc-Medium, Noto Sans CJK TC",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u8E89\u552E\u96FB\u7BB1"))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 81.822,
    transform: "translate(4322.82 102.408)",
    fill: "#fff",
    stroke: "#3fa9f5",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.346
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 68.842,
    transform: "translate(4621.837 188.085)",
    fill: "#fff",
    stroke: "#3fa9f5",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.346
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 68.842,
    transform: "translate(4384.839 188.085)",
    fill: "#fff",
    stroke: "#3fa9f5",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.346
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 81.822,
    transform: "translate(4524.86 98.964)",
    fill: "#fff",
    stroke: "#3fa9f5",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.346
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(4159 95.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_648",
    "data-name": "Rectangle 648",
    width: 105.93,
    height: 87.006,
    rx: 6,
    transform: "translate(6.21 6.73)",
    strokeWidth: 5.346,
    stroke: "#3fa9f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "\\u592A\\u967D\\u80FD\\u6A21\\u7D44",
    transform: "translate(4731.011 107.908)",
    fontSize: 20,
    fontFamily: "NotoSansCJKtc-Medium, Noto Sans CJK TC",
    fontWeight: 500,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u592A\u967D\u80FD\u6A21\u7D44")), /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(4705.265 204.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M-2082.063,935.866c.42.684-.509,1.1-1.015,1.293-2.069.267-3.463,2.215-4.687,3.663a.608.608,0,0,0,.211.8c2.576-1.257,4.981-2.823,8.233-2.556a.829.829,0,0,0,.169-1.185c-.255-.61-2.156-.343-1.013-1.293.5-.384,1.221-.8,1.856-.344,2.069.987,1.816,3.32,2.115,5.035a1.475,1.475,0,0,1-1.609.343,2.761,2.761,0,0,0-3.039-1.1,27.753,27.753,0,0,0-7.6,3.205,3.72,3.72,0,0,1-2.656-.612c-.214-.419-.551-.762-.214-1.222a37.36,37.36,0,0,1,6.713-6.676A3.507,3.507,0,0,1-2082.063,935.866Z",
    transform: "translate(2091.453 -933.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M-2078.556,944.335c.212.728-.505,1.494.17,2.025-.338,1.142-1.563,1.411-2.407,2.213-2.088.345-4.854.688-6.2-1.03.337-.993-1.016-1.6-.3-2.559a45.14,45.14,0,0,1,6-1.906C-2080.118,942.848-2079.273,943.647-2078.556,944.335Zm-5.911,1.3a1.245,1.245,0,0,0,.214,1.258c1.182.308,2.15-.382,3.164-.8.128-.5.633-.957.3-1.491A5.043,5.043,0,0,0-2084.467,945.635Z",
    transform: "translate(2091.701 -933.118)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(19.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M-2065.339,934.273c0,.378-.557,1.019.083,1.251a4.679,4.679,0,0,1,3.425-.453c.941.794-.9.982-1.155,1.627-1.241-.682-2.44.416-3.468,1.023-.513-.04-1.153-.229-1.24-.723.087-1.209-.428-2.879,1.24-3.295C-2066.069,933.891-2065.339,933.665-2065.339,934.273Z",
    transform: "translate(2073.26 -933.704)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M-2070.084,938.139c-.386.343-1.027.152-1.412,0-.342-.569-1.455-.985-1.025-1.7.383-.457.942-1.178,1.625-.913C-2070.767,936.437-2069.871,937.117-2070.084,938.139Z",
    transform: "translate(2072.951 -933.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M-2058.121,937.881c-.084,1.556-2.054,1.784-3.085,2.655-.211.645.943,1.324.091,2.009-.388.566-1.074,1.136-.816,1.819.858.756,2.742.907,2.57,2.347-.214,1.175-.26,2.388-1.239,3.3a9.872,9.872,0,0,1-6.465,1.058c-.173-.34.254-.57.513-.716,1.624-.38,3.894-.114,4.621-1.9-.042-.757.556-1.631-.086-2.275-.641-.6-1.668-.339-2.268-.909-.13-1.137,2.012-2.16.513-2.993-.684.038-1.326.873-1.969.153.131-1.746,2.485-1.439,3.6-2.427a1.6,1.6,0,0,0,.813-1.29c-1.967-.832-3.6.915-5.134,1.9-.773.3-1.5-1.02-1.927.114a27.678,27.678,0,0,0-.215,6.252,1.644,1.644,0,0,1-1.753.38c-1.458-1.438-1.241-3.487-2.571-5a2.261,2.261,0,0,1,1.329-2.011c.386-.077.855.117.855.459.255,1.135-.73,2.612.682,3.106.473-1.175.385-2.5.859-3.642,1.283-.3,1.967-2.5,3.6-1.476.728-.569,1.452-2.045,2.952-1.365,1.452,1.288,1.926-1.932,3.6-.453Z",
    transform: "translate(2072.932 -933.524)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M-2049.483,940.538c.12.336-.156.6-.474.7a2.037,2.037,0,0,1-1.615-.635.868.868,0,0,1,.547-.635A1.728,1.728,0,0,1-2049.483,940.538Z",
    transform: "translate(2093.957 -933.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M-2044.272,935.084c-.2,1.245-3.018.769-2.1,2.537,1.8.131,4.284-.793,5.7.4.6.589,1.552,1.267,1.153,2.048-.845.589-1.583,1.534-2.758,1.592a1.2,1.2,0,0,1-.853-.466c.093-.767,1.935-1.4,1.017-2.3a4.8,4.8,0,0,0-4.257.468c.31.964-.462,2.09.447,2.774,1.157-.459-.336-2.348,1.466-2.107.5.372.878.9.6,1.457-.242.341-.7.726-.333,1.139,1.391.766-.419,2.092.548,3.134.027,1.3-2.977-.144-2.228,1.671,1.1,1,2.9.361,4.352.579a1.067,1.067,0,0,1-.662,1.6c-1.755-.206-4.132.281-4.874-1.425.805-1.315-2.7-1.569-.475-2.482.119-.26-.151-.389-.334-.527-.812.294-.7,1.631-1.909,1.074-.629-.329-.961-.859-.812-1.376.19-1.386,2.058-1.552,3.016-2.51-.432-.736.242-2.114-.8-2.714-1.384.251-2.6,1.149-4,1.147-.585.5-.011,1.377-.74,1.774-.948.227-1.468-.542-2.138-.833a3.627,3.627,0,0,1,2.043-2.825c.347-.015.734-.107.974.205.058.324-.49.713.047.976.99-1.1,2.6-1.22,3.975-1.687.549-.388.253-1.067.059-1.488-.907-.643-2.975-.069-2.912-1.416.873-.8,2.354-.081,3.335-.529C-2046.686,934.841-2045.027,933.927-2044.272,935.084Zm-1.952,8.879a.53.53,0,0,0,.718.4.6.6,0,0,0,.321-.635C-2045.386,943.27-2046.389,943.393-2046.224,943.964Zm-1.808-.19a.368.368,0,0,0-.309.5c.055.157.285.1.444.085.37.111.365-.251.308-.4C-2047.552,943.711-2047.885,943.768-2048.032,943.773Z",
    transform: "translate(2093.726 -933.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M-2027.635,935.041a11.566,11.566,0,0,0-.22,2.17c1.408.494,3.519.611,3.78,2.289.088,2.665.309,5.712-2.638,6.967a2.28,2.28,0,0,1-2.109-.115c-.266-.19-.486-.417-.4-.722.661-.836,2.2-.153,2.637-1.294.267-1.716.881-3.5-.132-5.1a1.965,1.965,0,0,0-1.143-.46c-1.452,3.122-.835,6.971-3.384,9.675-.748.687-1.542,1.562-2.731.912a4.209,4.209,0,0,1-.834-.608c1.627-1.3,3.3-2.933,3.784-4.761.307-1.487,1.186-3.009.831-4.492-.657-.344-1.711.491-2.418-.19-.3-.154-.571-.382-.525-.726.745-.916,2.327-.38,3.078-1.183.131-.834-.792-1.635,0-2.36A1.93,1.93,0,0,1-2027.635,935.041Z",
    transform: "translate(2095.009 -933.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M-2003.769,939.692a2.488,2.488,0,0,1-.3,2.109,3.849,3.849,0,0,1-2.054-.781,7.832,7.832,0,0,1-1.461-4.017c1.116-1.033,2.233.635,3.3,1.173Z",
    transform: "translate(2096.718 -933.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M-2012.969,938c.126,2.643-1.459,4.751-2.49,7.053-.427.588-1.113,1.222-1.842.783-2.573-2.257,1.542-3.724,2.058-5.733C-2014.773,939.179-2014.217,937.462-2012.969,938Z",
    transform: "translate(2096.055 -933.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M-2009.2,940.033c.47,1.814-2.273,2.252-1.334,3.872a1.327,1.327,0,0,0,1.334-1.079c-.135-.832.512-1.177,1.115-1.177,1.8.1,2.829,2.352,3.514,3.921-.088.586-.728.882-1.112,1.177-1.332.194-1.2-1.669-2.191-2.156-1.8.833-3.387,2.89-5.529,1.911a1.326,1.326,0,0,1-.344-2,26.827,26.827,0,0,0,3.432-5.393C-2009.724,938.958-2009.548,939.591-2009.2,940.033Z",
    transform: "translate(2096.311 -933.366)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M-1986.87,936.332c1.739,1.561.956,4.034,1.433,6.051-.823,2.359,1.654,6.694-2.474,7.037a14.554,14.554,0,0,1-6.379-1.03c-.086-.228.221-.305.349-.457,2.081-.38,5.294.992,6.336-1.177,0-3.12.132-6.35-.739-9.208-.43-.951-1.65-.912-2.6-.762-1.479-.265-3.123,2.018-4.038,0-.086-1.975,2.472-.3,3.65-1.063C-1989.862,935.612-1987.956,935.039-1986.87,936.332Z",
    transform: "translate(2097.509 -933.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M-1989.49,938.663c-2.21,1.5-5.083,1.889-7.725,2.58-.831-.269-2-.422-2.307-1.269.917-.658,2,.078,3.045-.269a29.184,29.184,0,0,1,6.768-1.312Z",
    transform: "translate(2097.224 -933.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M-1990.5,941.036c-.13.926-.824,1.962.524,2.5.127.27-.175.464-.392.54-1.432.193-2.953.156-3.947,1.2-1.219,0-2.564-.153-3.039-1.271.126-.655-.35-1.7.6-1.847,2.085-.308,3.733-2.464,6.074-1.387Zm-3.518.732a1.39,1.39,0,0,0-.95,1.386c.171.459.7.5,1.172.459a1.47,1.47,0,0,0,1.04-1.459C-1992.972,941.768-1993.533,941.768-1994.015,941.768Z",
    transform: "translate(2097.36 -933.279)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4069, -46.33)",
    filter: "url(#Path_495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_495-2",
    "data-name": "Path 495",
    d: "M-2097.937,819.489a2.7,2.7,0,0,0,1.469-3.365l-2.892-7.944a2.7,2.7,0,0,0-3.288-1.633l-11.52,3.56a2.4,2.4,0,0,0-1.555,3.13l3.47,9.532a2.394,2.394,0,0,0,3.2,1.4Zm-19.682,8.285a2.7,2.7,0,0,0,1.47-3.365l-3.613-9.925a2.7,2.7,0,0,0-3.288-1.634l-17.818,5.506a2.394,2.394,0,0,0-1.555,3.129l4.413,12.126a2.393,2.393,0,0,0,3.2,1.4Zm-31.22-31.192a2.027,2.027,0,0,0-1.634,2.792l4.7,12.919a2.787,2.787,0,0,0,3.307,1.7l18-5.036a2.319,2.319,0,0,0,1.574-3.065l-3.793-10.421a3.188,3.188,0,0,0-3.368-1.971Zm67.433,15.949a2.7,2.7,0,0,0,1.469-3.365l-2.286-6.28a2.7,2.7,0,0,0-3.288-1.633l-8.254,2.55a2.394,2.394,0,0,0-1.553,3.13l2.748,7.551a2.4,2.4,0,0,0,3.2,1.4Zm-22.458-9.339a2.318,2.318,0,0,0,1.574-3.065l-2.975-8.171a3.185,3.185,0,0,0-3.367-1.971l-12.174,2a2.028,2.028,0,0,0-1.635,2.792l3.631,9.974a2.786,2.786,0,0,0,3.308,1.7Zm11.99,32.831a3.191,3.191,0,0,0,1.312-3.675l-2.974-8.171a2.318,2.318,0,0,0-3.176-1.336l-11.01,4.987a2.786,2.786,0,0,0-1.442,3.426l3.632,9.976a2.028,2.028,0,0,0,3.046,1.088Zm-7.515-47.554a2.027,2.027,0,0,0-1.633,2.792l2.811,7.724a2.789,2.789,0,0,0,3.307,1.7l8.342-2.334a2.319,2.319,0,0,0,1.573-3.065l-2.285-6.279a3.187,3.187,0,0,0-3.368-1.971Zm-11.152,58.63a3.189,3.189,0,0,0,1.312-3.675L-2113.023,833a2.317,2.317,0,0,0-3.175-1.336l-17.027,7.71a2.789,2.789,0,0,0-1.441,3.427l4.7,12.922a2.028,2.028,0,0,0,3.047,1.088Zm34.344-20.38a3.188,3.188,0,0,0,1.311-3.675l-2.285-6.279a2.319,2.319,0,0,0-3.177-1.336l-7.889,3.573a2.788,2.788,0,0,0-1.441,3.426l2.812,7.725a2.028,2.028,0,0,0,3.046,1.088Z",
    transform: "translate(2725.65 -672.67)",
    fill: "#9a9a9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_328-2",
    "data-name": "Group 328",
    transform: "translate(4726.521 133.463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M89.942,56.932l-6.362,8.25V61.417L69.332,81.323,80.626,68.947l-.094,3.947,6.186-8.432.175,2.065,7.533-10.4-5.466,4.483Z",
    transform: "translate(-34.346 -21.302)",
    fill: "#dc000c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M83.576,48.836,83.4,45.068l6.455,7.981-.806-3.676,5.372,4.573-7.8-10.761v2.331l-6.268-8.428.175,3.763L69.059,28.75Z",
    transform: "translate(-34.342 -20.914)",
    fill: "#dc000c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M46.513,53.408l6.279-7.981v3.588L67.041,28.84,55.573,41.482l.269-4.211-6.362,8.605V43.633L41.947,54.305l5.29-4.571Z",
    transform: "translate(-33.958 -20.915)",
    fill: "#dc000c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M52.793,61.416,52.968,65,46.513,57.02l.993,3.859-5.559-4.844,7.708,10.759V64.461l6.362,8.521-.175-3.943L67.228,81.321Z",
    transform: "translate(-33.958 -21.3)",
    fill: "#dc000c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_327-2",
    "data-name": "Group 327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M91.716,30.733A33.9,33.9,0,1,0,101.643,54.7,33.653,33.653,0,0,0,91.716,30.733ZM67.744,86.946A32.244,32.244,0,1,1,99.985,54.7,32.276,32.276,0,0,1,67.744,86.946Z",
    transform: "translate(-33.843 -20.801)",
    fill: "#00589e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M67.7,23.677a30.994,30.994,0,1,0,31,30.992A31.029,31.029,0,0,0,67.7,23.677Zm0,60.47A29.478,29.478,0,1,1,97.188,54.668,29.5,29.5,0,0,1,67.7,84.147Z",
    transform: "translate(-33.884 -20.842)",
    fill: "#00589e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M67.743,26.547A28.164,28.164,0,1,0,95.92,54.709,28.193,28.193,0,0,0,67.743,26.547Zm0,54.95a26.787,26.787,0,1,1,26.8-26.788A26.814,26.814,0,0,1,67.743,81.5Z",
    transform: "translate(-33.924 -20.882)",
    fill: "#00589e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M68.795,53.572h9.869l-.7-1.779H58.344l-.795,1.779,9.46.01L67,55.021H57.036l2.885,6.7h1.974l-2.055-4.877h1.74l2.173,4.877,1.915-.014L63.6,56.8l3.41-.014L67,63.121H60.4l3.574,8.049,3.072-.009v7.03l1.33,2.9,3.5-8.423H69.917l-1.028,2.71V71.17h3.6l3.294-8.054-6.985-.023.012-6.3,3.877.014-2.16,4.91h2.009l2.055-4.938h2.055l-2.055,4.9,1.774.024,2.826-6.681L68.795,55ZM63.927,66.256l-.655-1.406H67.01v1.406ZM67,69.5l-1.67-.015-.7-1.5L67.021,68Zm4.309-.015-2.5-.009-.012-1.491h3.1ZM73.245,64.9l-.631,1.378-3.807-.01L68.795,64.9Z",
    transform: "translate(-34.172 -21.24)",
    fill: "#00589e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M73.581,41.967H62.615L59.31,49.551H76.98Zm-9.763,1.754H72.46l1.752,4H62.126Z",
    transform: "translate(-34.204 -21.101)",
    fill: "#00589e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M70.135,33.64l-.993,2.177,1.2,2.667h-4.3l3.175-6.951-1-2.387-4.835,11.1h9.622Z",
    transform: "translate(-34.262 -20.919)",
    fill: "#00589e"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMiaoliDisplayBanner);
export default __webpack_public_path__ + "static/media/bg_miaoli_display_banner.36c28335adb365e41ad3799c55c7a0f0.svg";
export { ForwardRef as ReactComponent };